import { render, staticRenderFns } from "./FormPricePeriod.vue?vue&type=template&id=81ff714a&"
import script from "./FormPricePeriod.vue?vue&type=script&lang=js&"
export * from "./FormPricePeriod.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports